import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { Dropdown } from "@eudonet/opal";
import { selectLocale, SWITCHABLE_LOCALES } from "@/shared/i18n";
import frFlag from "@/assets/flags/fr.svg";
import enFlag from "@/assets/flags/en.svg";
import nlFlag from "@/assets/flags/nl.svg";
import caFlag from "@/assets/flags/ca.svg";
export default /*@__PURE__*/ _defineComponent({
    __name: 'LanguageSwitcher',
    setup(__props) {
        const { locale, t } = useI18n();
        /** Circular country flag per switchable locale (matches the Figma dropdown). */
        const FLAGS = {
            "fr-FR": frFlag,
            "en-US": enFlag,
            "nl-NL": nlFlag,
            "fr-CA": caFlag,
        };
        /**
         * i18n key for each locale's endonym. fr-FR reuses `language.fr` (no duplicate "Français" key);
         * fr-CA has its own `language.fr-CA` ("Français (Canada)").
         */
        const LABEL_KEY = {
            "fr-FR": "language.fr",
            "en-US": "language.en",
            "nl-NL": "language.nl",
            "fr-CA": "language.fr-CA",
        };
        /** Each offered locale shows its flag + endonym; the active one is flagged. */
        const items = computed(() => SWITCHABLE_LOCALES.map((code) => ({
            label: t(LABEL_KEY[code]),
            icon: FLAGS[code],
            active: locale.value === code,
            onClick: () => selectLocale(code),
        })));
        /** Active item (falls back to the first offered locale). */
        const currentItem = computed(() => items.value.find((item) => item.active) ?? items.value[0]);
        const currentLabel = computed(() => currentItem.value.label);
        const currentFlag = computed(() => currentItem.value.icon);
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(Dropdown), {
                label: currentLabel.value,
                "trigger-icon-left": currentFlag.value,
                items: items.value,
                "aria-label": _ctx.$t('languageSwitcher.label')
            }, null, 8 /* PROPS */, ["label", "trigger-icon-left", "items", "aria-label"]));
        };
    }
});
